export interface Country {
  name: string;
  code: CountryCode;
}

export type CountryCode = 'NO' | 'SE' | 'DE';

export const BOOKING_AVAILABLE_COUNTRY_CODES: CountryCode[] = ['NO'];
